import React from "react";
import '../../assets/css/style.css';
import CardLogo from '../../assets/img/cardlogo.svg';
import CkeckImg from '../../assets/img/check.svg';

const CardItemsDan = ({ cards }) => {
  return (
    <div className="cards-div-1" id="cards-list">
      {cards.length > 0 ? (
        cards.map((card, index) => (
          <div key={index} id="usercard" className="cards-div-2">
            <img src={CardLogo} className="cards-logo-1" alt="cardlogo" />
            <img src={CkeckImg} className="cards-check-1" alt="check" />
            <p className="cards-p-1">{card.card_name}</p>
            <p className="cards-p-2">{card.user_shaba}</p>
          </div>
        ))
      ) : (
        <p className="text-center">هیچ کارتی ثبت نشده است.</p>
      )}
    </div>
  );
};

export default CardItemsDan;
